<template>
  <div class="home">
    <h1> Learn Sheet Music </h1>
    <Game />
  </div>
</template>

<script>
// @ is an alias to /src
import Game from "@/components/Game.vue";

export default {
  name: "Home",
  components: {
    Game
  }
};
</script>
